export default {
  list: {
    title: "骑手列表",
    namePh: "请输入骑手姓名",
    telPh: "请输入骑手手机号",
    name: "骑手姓名",
    tel: "骑手手机号",
  },
  auth: {
    title: "认证审核列表",
    addRider: "新增骑手",
    batchPass: "批量通过",
    batchReject: "批量拒绝",
    status: "状态",
    allStatus: "全部状态",
    pendingReview: "待审核",
    idCard: "身份证号",
    authStatus: "认证状态",
    bindPhone: "绑定手机号",
    authReject: "认证审核拒绝",
    telPh: "请输入骑手手机号",
  },
  prize: {
    title: "骑手奖惩",
    rewardSet: "奖励设置",
    punishSet: "惩罚设置",
    add: "添加",
    riderId: "骑手ID",
    punishType: "惩罚类型",
    reward: "奖励",
    punish: "惩罚",
    category: "奖惩类别",
    changeBalance: "变更余额",
    noticeWarn: "通知警告",
    forbidOrder: "禁止接单",
    freezeAccount: "冻结账号",
    amount: "奖惩金额",
    reason: "奖惩原因说明",
    appealing: "申述中",
    executing: "执行",
    revoked: "撤销",
  },
  level: {
    title: "骑手等级列表",
    addLevel: "新增等级",
    levelName: "骑手等级",
    levelTitle: "等级名称",
    levelSetting: "等级设置",
    levelIcon: "等级图标",
    levelNamePh: "请输入等级名称",
    dailyMerge: "每日并单(单)",
    dailyMergePh: "请输入每日接单数",
    dailyTransfer: "每日转单(单)",
    dailyTransferPh: "请输入每日转单数",
    dailyCancel: "每日取消(单)",
    dailyCancelPh: "请输入每日可取消数",
    commissionRatio: "佣金比例(百分比)",
    commissionRatioPh: "请输入抽成比例",
    upgradeCondition: "升级条件(单)",
    upgradeConditionPh: "请输入升级条件",
    riderCount: "骑手数量(人)",
    peopleDetail: "人数详情",
    nickname: "昵称",
    orderCount: "接单数",
    levelN: "{n}级",
  },
  health: {
    title: "健康证审核列表",
    frontImg: "健康证正面",
    submitTime: "提交时间",
    auditStatus: "审核状态",
    pending: "待审核",
    approved: "审核通过",
    rejected: "审核拒绝",
    frontPhoto: "正面照",
    namePh: "请输入骑手姓名",
  },
  settings: {
    title: "骑手设置",
    orderCondition: "骑手接单条件",
    realNameAuth: "实名认证",
    deposit: "缴纳保证金",
    orderConditionTip: "注意：骑手接单前必须要先通过骑手认证",
    pickUpCondition: "骑手取货条件",
    none: "无",
    pickUpCode: "取货码",
    pickUpPhoto: "取件照片",
    pickUpTip: "开启后，骑手到店后需要上传收件图片，才可进行下一步操作",
    deliveryCondition: "骑手送达条件",
    deliveryCode: "收货码",
    deliveryPhoto: "收件照片",
    deliveryTip: "开启后，骑手到店后需要上传收件图片，才可进行下一步操作",
    orderRangeLimit: "接单范围限制",
    orderRangePh: "请输入骑手接单范围限制",
    withinKm: "公里以内",
    orderRangeTip: "骑手接单范围距离限制，如骑手只能接当前定位的3公里内的订单",
    arrivalDistanceLimit: "到店距离限制",
    arrivalDistancePh: "请输入骑手接单范围限制",
    withinMeter: "米以内",
    arrivalDistanceTip: "骑手离商家多少米内，可以点击到店按钮",
    serviceDistanceLimit: "送达距离限制",
    serviceDistancePh: "请输入送达距离限制",
    serviceDistanceTip: "骑手离用户多少米内，可以点击送达按钮",
    arrivalTimeLimit: "到店时间限制",
    enterKm: "请输入公里数",
    withinKmShort: "公里内",
    enterMinute: "请输入分钟",
    minuteComplete: "分钟完成",
    afterKm: "公里以后",
    perKmAdd: "每公里加",
    minute: "分钟",
    serviceTimeLimit: "送达时间限制",
  },
  detail: {
    title: "配送员详情",
    userUid: "用户UID：",
    withdrawable: "可提现余额",
    points: "积分",
    realName: "真实姓名",
    realNamePh: "请输入真实姓名",
    riderAccount: "骑手账号",
    riderAccountPh: "请输入骑手账号",
    riderPassword: "骑手密码",
    riderPasswordPh: "请输入骑手密码",
    wxAdmin: "关联微信管理员",
    wxAdminPh: "关联微信管理员",
    portrait: "骑手头像",
    regTime: "注册时间",
    bindPhone: "绑定手机号",
    bindPhonePh: "请输入绑定手机号",
    gender: "性别",
    age: "年龄",
    agePh: "请输入年龄",
    urgentContact1: "紧急联系电话1",
    urgentContact1Ph: "请输入紧急联系方式1",
    urgentContact2: "紧急联系电话2",
    urgentContact2Ph: "请输入紧急联系方式2",
    homeAddress: "家庭住址",
    homeAddressPh: "请输入家庭住址",
    riderType: "骑手类型",
    riderTypePh: "请选择骑手类型",
    fullTime: "全职",
    partTime: "兼职",
    riderLevel: "骑手等级",
    idCard: "身份证号",
    idCardPh: "请输入身份证号",
    idCardPhoto: "身份证照片",
    idCardFront: "身份证正面",
    idCardBack: "身份证反面",
    bond: "保证金",
    unpaidBond: "未缴纳",
    paidBond: "已缴纳",
    healthCert: "健康证",
    authStatus: "认证状态",
    orderStats: "订单统计",
    totalOrders: "累计接单量",
    totalTrips: "累计旅程数",
    totalCommission: "累计佣金",
    complaintViolation: "投诉/违规",
  },
  form: {
    addTitle: "新增骑手",
  },
};
